interface IDataItem {
  emailAddress?: string
  id?: number | string
  answerID?: number | string
  departmentID?: number | string
}

export const strongCopyData = <T>(data: T): T => structuredClone(data)

export const filterOrAddItem = ({
  item,
  oldData,
}: {
  item: IDataItem
  oldData: IDataItem[]
}): IDataItem[] => {
  const key = item.emailAddress || item.id || item.answerID || item.departmentID

  const exists = oldData.some(
    data =>
      (data.emailAddress || data.id || data.answerID || data.departmentID) ===
      key,
  )

  if (exists) {
    return oldData.filter(
      data =>
        (data.emailAddress || data.id || data.answerID || data.departmentID) !==
        key,
    )
  } else {
    return [...oldData, item]
  }
}

export const dataUtil = {strongCopyData, filterOrAddItem} as const
